import type { CountryRes } from 'api/swagger';

export const transformCountriesForForm = (countries?: CountryRes[]): { value: number; label: string }[] => {
  if (!countries) return [];

  return countries.map((country) => ({
    value: country.id,
    label: `${country.code} - ${country.name}`,
  }));
};
